export default __webpack_public_path__ + "static/media/Exaltate's Bracers.78a8ac5b.jpg";